import { createFileRoute } from "@tanstack/react-router";
import Bugs from "@/components/Bugs";

function RouteComponent() {
  return <Bugs />;
}

export const Route = createFileRoute("/_authenticated/chat/bugs/")({
  component: RouteComponent,
  staticData: { page: "support" },
});
